<script>
import Utils from '@/common/Utils';
import CommonConstants from '@/common/Constants';
import ResponsiveButton from '@/components/generic/ResponsiveButton.vue';
import Service from '../../services/demurrage';
import ServiceJetty from '../../services/jetty';
import CommonService from '@/services/common';

import GenericCustomMasterDataAutocompleteV2 from '@/components/generic/GenericCustomMasterDataAutocompleteV2.vue';
import { useVuelidate } from '@vuelidate/core';
import GenericCustomAutocompleteV2 from '../generic/GenericCustomAutocompleteV2.vue';
import HourMinuteField from '../generic/HourMinuteField.vue';
export default {
    props: ['id'],
    setup: () => ({ v$: useVuelidate() }),
    components: {
        GenericCustomMasterDataAutocompleteV2,
        GenericCustomAutocompleteV2,
        ResponsiveButton,
        HourMinuteField
    },
    data() {
        return {
            isLoaded: false,
            submitted: false,
            itemsHeader: null,
            itemsDetail: null,
            itemsReason: null,
            idMovementInstructionHeader: Number(this.$route.params.id ? this.id : null),
            grossLaytime: null,
            totalNetUsedtimeMinutes: null,
            totalDeductionsMinutes: null,
            timeOnDemurrageMinutes: null,
            layday: null,
            data: [],
            params: {},
            onlyOpened: false,
            deductionDialog: false,
            regenerateDialog: false,
            deduction: {},
            deductionItems: [],
            idDeductionSelected: null,
            totalDeductionItemHrs: null,
            totalDeductionItemMins: null,
            totalDeductionItemTotalHrs: null,
            totalReasonMins: null,
            totalReasonHrs: null,
            totalReasonTotalHrs: null,
            totalDemurrageReason: null,
            totalDeltaReasonMins: null,
            totalDeltaReasonHrs: null,
            totalDeltaReasonTotalHrs: null,
            totalDemurrageDeltaReason: null,
            signOperations: [
                {
                    value: true,
                    label: this.$t('DemurrageCalculator.sum'),
                },
                {
                    value: false,
                    label: this.$t('DemurrageCalculator.difference'),
                },
            ],
            sourceOperations: [
                {
                    value: true,
                    label: this.$t('DemurrageCalculator.timesheet'),
                },
                {
                    value: false,
                    label: this.$t('DemurrageCalculator.fixedValue'),
                },
            ],
            deductionItemConf: {
                descriptionItem: null,
                sharePercent: null,
                signSelected: {},
                sourceSelected: false,
                timesheetOptionsStartDate: [],
                timesheetOptionsEndDate: [],
                fixedHrsItem: null,
                fixedMinsItem: null,
                timesheetStartDate: null,
                timesheetEndDate: null,
            },
            deliveryDocuments: [],
            indexDeductionItem: null,
            voyagesSelected: {},
            mailDialog: false,
            note: '',
            timesheetItems: [
                {
                    label: this.$t('btn.timesheet'),
                    command: () => {
                        this.onRouteToTimesheetDetail();
                    },
                },
                {
                    label: this.$t('btn.download'),
                    command: () => {
                        this.printTimesheetPdf();
                    },
                },
            ],
            downloadItems: [
                {
                    label: this.$t('DemurrageCalculator.btn.internal'),
                    command: () => {
                        this.exportExcel(true);
                    },
                },
                {
                    label: this.$t('DemurrageCalculator.btn.notInternal'),
                    command: () => {
                        this.exportExcel(false);
                    },
                },
            ],
            demurrageAttachments: [],
            attachmentsDialogVisible: false,
            newDocument: {
                description: ''
            }
        };
    },
    created() {
        this.onRouteFromRegister();
    },
    computed: {
        constants() {
            return CommonConstants;
        },
        utils() {
            return Utils;
        },
        uiPermissions() {
            return this.$store.getters['security/uiPermissions'];
        },
        canShowCard() {
            return this.isLoaded && this.itemsHeader && this.itemsHeader.idMovementInstructionHeader;
        },
    },
    watch: {
        onlyOpened() {
            this.$refs.voyagesCombo.forceLoadOptions('movement-instruction/voyage-number-combo?transportType=N,B&onlyOpened=' + this.onlyOpened);
        },
    },
    methods: {
        onRouteFromRegister() {
            if (this.id != null) {
                this.idMovementInstructionHeader = this.id;
                this.loadHeader();
            }
        },

        onRouteToTimesheetDetail() {
            this.$router.push({ name: 'timesheet', query: { defaultVoyageNumber: this.voyagesSelected.extraData }, params: { onlyOpened: false } });
        },

        //format methods
        formatDateRange(startDate, endDate) {
            const start = new Date(startDate);
            const end = new Date(endDate);
            return `${this.formatDateDaysMonth(start)} - ${this.formatDateDaysMonth(end)}`;
        },

        formatDateDaysMonth(date) {
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            return `${day}.${month}`;
        },

        formatTotalMins(date) {
            return date ? Math.floor(date.getTime() / 60000) : 0;
        },

        formatHrsMins(value) {
            const absValue = Math.abs(value);
            const hrs = Math.floor(absValue / 60);
            const mins = absValue % 60;
            const sign = value < 0 ? '-' : '';
            return `${sign}${hrs.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')}`;
        },

        setFirstDayOfMonth(date) {
            let newDate = new Date(date.getTime());
            newDate.setHours(0, 0, 0, 0);
            newDate.setDate(1);
            newDate.setMonth(newDate.getMonth());
            return newDate;
        },

        formatDates() {
            this.itemsHeader.layTimeCommenced = this.itemsHeader.layTimeCommenced ? Utils.dateToCurrentTimeZone(this.itemsHeader.layTimeCommenced) : null;
            this.itemsHeader.noticeOfReadiness = this.itemsHeader.noticeOfReadiness ? Utils.dateToCurrentTimeZone(this.itemsHeader.noticeOfReadiness) : null;
            this.itemsHeader.hosesDisconnection = this.itemsHeader.hosesDisconnection ? Utils.dateToCurrentTimeZone(this.itemsHeader.hosesDisconnection) : null;
            this.itemsHeader.laycanStartDate = this.itemsHeader.laycanStartDate ? Utils.dateToCurrentTimeZone(this.itemsHeader.laycanStartDate) : null;
            this.itemsHeader.laycanEndDate = this.itemsHeader.laycanEndDate ? Utils.dateToCurrentTimeZone(this.itemsHeader.laycanEndDate) : null;
            this.layday = this.formatDateRange(this.itemsHeader.laycanStartDate, this.itemsHeader.laycanEndDate);
            this.itemsHeader.documentOnBoard = this.itemsHeader.documentOnBoard ? Utils.dateToCurrentTimeZone(this.itemsHeader.documentOnBoard) : null;
            this.grossLaytime = this.itemsHeader.grossLaytime ? this.formatHrsMins(this.itemsHeader.grossLaytime) : null;
            this.totalNetUsedtimeMinutes = this.itemsHeader.totalNetUsedtimeMinutes ? this.formatHrsMins(this.itemsHeader.totalNetUsedtimeMinutes) : 0;
            this.totalDeductionsMinutes = this.itemsHeader.totalDeductionsMinutes ? this.formatHrsMins(this.itemsHeader.totalDeductionsMinutes) : 0;
            this.timeOnDemurrageMinutes = this.itemsHeader.timeOnDemurrageMinutes ? this.formatHrsMins(this.itemsHeader.timeOnDemurrageMinutes) : 0;
            this.itemsHeader.cargoDocumentsFrom = this.itemsHeader.cargoDocumentsFrom ? Utils.dateToCurrentTimeZone(this.itemsHeader.cargoDocumentsFrom) : null;
            this.itemsHeader.cargoDocumentsTo = this.itemsHeader.cargoDocumentsTo ? Utils.dateToCurrentTimeZone(this.itemsHeader.cargoDocumentsTo) : null;
            this.itemsHeader.cargoDocumentsAllowanceFrom = this.itemsHeader.cargoDocumentsAllowanceFrom ? Utils.dateToCurrentTimeZone(this.itemsHeader.cargoDocumentsAllowanceFrom) : null;
            this.itemsHeader.cargoDocumentsAllowanceTo = this.itemsHeader.cargoDocumentsAllowanceTo ? Utils.dateToCurrentTimeZone(this.itemsHeader.cargoDocumentsAllowanceTo) : null;
        },

        //Header Calculator

        onVoyageSelected(el) {
            this.voyagesSelected = {
                extraData: el.extraData,
                label: el.label,
            };
            if (this.itemsHeader && this.idMovementInstructionHeader != this.itemsHeader.idMovementInstructionHeader) {
                this.isLoaded = false;
            } else {
                this.isLoaded = true;
            }
        },

        loadHeader() {
            this.$store.dispatch('generic/setLoading', true);
            Service.getCalculatorHeader(this.idMovementInstructionHeader, (response) => {
                if (response.success && !response.notFound) {
                    this.itemsHeader = response.data;
                    this.loadDetail();
                    this.formatDates();
                    this.loadReason();
                    this.mapDeliveryDocuments();
                    this.isLoaded = true;
                    this.loadAttachments();
                } else if (response.success && response.notFound) {
                    this.showCreateCalculatorHeader();
                } else {
                    this.$toast.add({ detail: response.message && response.message != '' ? response.message : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                }
                this.$store.dispatch('generic/setLoading', false);
            });
        },
        loadAttachments(){
            this.demurrageAttachments = [];
            CommonService.loadGeneric('attachments-get-by-voyage-number', {voyageNumber: this.itemsHeader.voyageNumber, scope: 'Demurrage'}, response => {
                if(response.success){
                    this.demurrageAttachments = response.data;
                }
            })
        },
        updateHeader() {
            this.$store.dispatch('generic/setLoading', true);
            Service.updateCalculatorHeader(this.itemsHeader, (response) => {
                this.$store.dispatch('generic/setLoading', false);
                if (response.success) {
                    this.loadHeader();
                    this.formatDates();
                    this.$toast.add({ severity: 'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000 });
                } else {
                    this.$toast.add({ detail: response.message && response.message != '' ? response.message : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                }
            });
        },

        showCreateCalculatorHeader() {
            if (this.uiPermissions('DemurrageAdminUI').isEnabled) {
                this.$confirm.require({
                    message: this.$t('DemurrageCalculator.messages.createCalculator'),
                    icon: 'pi pi-exclamation-triangle',
                    acceptLabel: this.$t('yes'),
                    rejectLabel: this.$t('no'),
                    accept: () => {
                        this.$store.dispatch('generic/setLoading', true);
                        Service.createCalculatorHeader(this.idMovementInstructionHeader, (response) => {
                            this.$store.dispatch('generic/setLoading', false);
                            if (response.success) {
                                this.loadHeader();
                                this.$toast.add({ severity: 'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000 });
                            } else {
                                this.$toast.add({ detail: response.message && response.message != '' ? response.message : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                            }
                        });
                    },
                    reject: () => {
                        this.$confirm.close();
                    },
                });
            } else {
                this.$toast.add({ detail: this.$t('DemurrageCalculator.messages.noCalculatorCreated'), life: 3000, severity: 'error' });
            }
        },

        onRegenerateCalculator(force) {
            Service.regenerateCalculatorHeader(this.idMovementInstructionHeader, force, (response) => {
                if (response.success) {
                    this.itemsHeader = response.data;
                    this.loadHeader();
                    this.$toast.add({ severity: 'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000 });
                } else {
                    this.$toast.add({ detail: response.message && response.message != '' ? response.message : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                }
                this.$store.dispatch('generic/setLoading', false);
            });
            this.regenerateDialog = false;
        },

        // Deductions details
        loadDetail() {
            this.$store.dispatch('generic/setLoading', true);
            Service.getCalculatorDetail(this.itemsHeader.id, (response) => {
                if (response.success) {
                    this.itemsDetail = response.data.map((item) => ({
                        ...item,
                        isEdit: false,
                    }));
                }
            });
            this.$store.dispatch('generic/setLoading', false);
        },

        onDeleteDetailDeduction(data, event) {
            this.$confirm.require({
                target: event.currentTarget,
                message: this.$t('messages.delete_message_question'),
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: this.$t('yes'),
                rejectLabel: this.$t('no'),
                accept: () => {
                    this.$store.dispatch('generic/setLoading', true);
                    Service.deleteDeductionDetail(data.id, (response) => {
                        this.$store.dispatch('generic/setLoading', false);
                        if (response.success) {
                            this.$confirm.close();
                            this.loadHeader();
                            this.$toast.add({ severity: 'success', summary: 'Success Message', detail: this.$t('messages.delete_message_success'), life: 3000 });
                        } else {
                            this.$toast.add({ detail: response.message && response.message != '' ? response.message : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                        }
                    });
                },
                reject: () => {
                    this.$confirm.close();
                },
            });
        },

        // Deduction items

        loadDeductionDetail() {
            this.$store.dispatch('generic/setLoading', true);
            Service.getCalculatorDetailDeduction(this.idDeductionSelected, (response) => {
                this.$store.dispatch('generic/setLoading', false);
                if (response.success) {
                    this.deduction = response.data;
                    if (response.data.isComposed == true) {
                        this.deductionItems = response.data.children;
                        this.getTotatDeductionItem();
                    }
                }
            });
        },

        onCheckAddDeductionItem() {
            if (this.deductionItemConf.descriptionItem && this.deductionItemConf.signSelected.value !== null) {
                if (this.deductionItemConf.sourceSelected.value == true) {
                    if (this.deductionItemConf.timesheetStartDate && this.deductionItemConf.timesheetEndDate) {
                        return true;
                    }
                } else if (this.deductionItemConf.fixedMinsItem || this.deductionItemConf.fixedHrsItem) {
                    return true;
                }
            }
            return false;
        },

        onCheckSaveDeductionItem() {
            return this.deduction.deductionDescription && this.deduction.sharePercent && this.deductionItems.length !== 0;
        },

        addDeductionItem() {
            this.submitted = true;
            const item = {
                idDemurrageCalculatorHeader: this.itemsHeader.id,
                deductionDescription: this.deductionItemConf.descriptionItem,
                isAdd: this.deductionItemConf.signSelected.value,
                idTimesheetDetailStartDate: this.deductionItemConf.timesheetOptionsStartDate,
                idTimesheetDetailEndDate: this.deductionItemConf.timesheetOptionsEndDate,
                totalMinutes: this.calculateHrsMins(),
                dateFrom: this.deductionItemConf.timesheetStartDate,
                dateTo: this.deductionItemConf.timesheetEndDate,
            };
            if (this.onCheckAddDeductionItem()) {
                if (item.dateFrom > item.dateTo) {
                    this.$toast.add({ detail: this.$t('DemurrageCalculator.messages.error_valid_date'), life: 3000, severity: 'error' });
                } else {
                    if (this.deductionItems[this.indexDeductionItem]) {
                        this.deductionItems[this.indexDeductionItem] = item;
                    } else {
                        this.deductionItems.push(item);
                    }
                    this.getTotatDeductionItem();
                    this.resetDeductionItem();
                }
            } else {
                this.$toast.add({ detail: this.$t('DemurrageCalculator.messages.error_valid_deduction'), life: 3000, severity: 'error' });
            }
        },

        deleteDeductionItem(data) {
            this.$confirm.require({
                target: event.currentTarget,
                message: this.$t('messages.delete_message_question'),
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: this.$t('yes'),
                rejectLabel: this.$t('no'),
                accept: () => {
                    this.deductionItems.splice(data.index, 1);
                    this.getTotatDeductionItem();
                },
                reject: () => {
                    this.$confirm.close();
                },
            });
        },

        onSaveDeductionDetailItem() {
            if (this.onCheckSaveDeductionItem()) {
                this.saveDeductionDetailItems();
                this.idDeductionSelected = null;
                this.indexDeductionItem = null;
                this.deductionDialog = false;
                this.loadHeader();
                this.clearDialog();
            } else {
                this.$toast.add({ detail: this.$t('DemurrageCalculator.messages.error_valid_deduction'), life: 3000, severity: 'error' });
            }
        },

        saveDeductionDetailItems() {
            const payload = {
                id: this.idDeductionSelected ? this.idDeductionSelected : null,
                idDemurrageCalculatorHeader: this.itemsHeader.id,
                deductionDescription: this.deduction.deductionDescription,
                sharePercent: this.deduction.sharePercent,
                children: this.mapDeductionItem(this.deductionItems),
            };
            this.$store.dispatch('generic/setLoading', true);
            Service.createCalculatorDeduction(payload, (response) => {
                if (response.success) {
                    this.loadHeader();
                    this.resetDeductionItem();
                    this.$toast.add({ severity: 'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000 });
                } else {
                    this.$toast.add({ detail: response.message && response.message != '' ? response.message : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                }
                this.$store.dispatch('generic/setLoading', false);
            });
        },

        onChangeSourceSelected() {
            this.deductionItemConf.timesheetOptionsEndDate = null;
            this.deductionItemConf.timesheetOptionsStartDate = null;
            this.deductionItemConf.timesheetStartDate = null;
            this.deductionItemConf.timesheetEndDate = null;
            this.deductionItemConf.fixedHrsItem = null;
            this.deductionItemConf.fixedMinsItem = null;
        },

        resetDeductionItem() {
            this.deductionItemConf.descriptionItem = null;
            this.deductionItemConf.signSelected = this.signOperations[0];
            this.deductionItemConf.sourceSelected = false;
            this.deductionItemConf.timesheetStartDate = null;
            this.deductionItemConf.timesheetEndDate = null;
            this.deductionItemConf.timesheetOptionsEndDate = null;
            this.deductionItemConf.timesheetOptionsStartDate = null;
            this.deductionItemConf.fixedHrsItem = null;
            this.deductionItemConf.fixedMinsItem = null;
            this.indexDeductionItem = null;
            this.submitted = false;
        },

        mapDeductionItem(data) {
            return data.map(({ idDemurrageCalculatorHeader, deductionDescription, isAdd, idTimesheetDetailStartDate, idTimesheetDetailEndDate, totalMinutes, dateFrom, dateTo }) => ({
                idDemurrageCalculatorHeader,
                deductionDescription,
                isAdd,
                idTimesheetDetailStartDate,
                idTimesheetDetailEndDate,
                totalMinutes,
                dateFrom,
                dateTo,
            }));
        },

        calculateHrsMins() {
            if (this.deductionItemConf.sourceSelected.value == true) {
                const startDate = this.deductionItemConf.timesheetStartDate;
                const endDate = this.deductionItemConf.timesheetEndDate ? this.deductionItemConf.timesheetEndDate : 0;
                const totalMin = this.formatTotalMins(endDate) - this.formatTotalMins(startDate);
                return totalMin;
            } else {
                return this.deductionItemConf.fixedHrsItem * 60 + this.deductionItemConf.fixedMinsItem;
            }
        },

        getTotatDeductionItem() {
            this.totalDeductionItemMins = this.calculateTotalMinsItems() ? ((this.calculateTotalMinsItems() * (this.deduction.sharePercent ? this.deduction.sharePercent : 0)) / 100).toFixed(0) : 0;
            this.totalDeductionItemHrs = this.formatHrsMins(this.totalDeductionItemMins);
            this.totalDeductionItemTotalHrs = (this.totalDeductionItemMins / 60).toFixed(2);
        },

        calculateTotalMinsItems() {
            const total = this.deductionItems.reduce((sum, item) => {
                const value = item.totalMinutes || 0;
                return item.isAdd ? sum + value : sum - value;
            }, 0);
            return total;
        },

        calculateSimpleMinsDeduction(endDate, startDate, share) {
            return ((this.formatTotalMins(endDate) - this.formatTotalMins(startDate)) * (share ? share : 0)) / 100;
        },

        onSelectTimesheetStartDate(event) {
            if (event.value && !this.deductionItemConf.timesheetStartDate) {
                if (event.value.startDate) {
                    this.deductionItemConf.timesheetStartDate = Utils.dateToCurrentTimeZone(event.value.startDate);
                } else {
                    this.deductionItemConf.timesheetStartDate = null;
                }
            }
        },

        onSelectTimesheetEndDate(event) {
            if (event.value && !this.deductionItemConf.timesheetEndDate) {
                if (event.value.endDate) {
                    this.deductionItemConf.timesheetEndDate = Utils.dateToCurrentTimeZone(event.value.endDate);
                } else if (event.value.startDate) {
                    this.deductionItemConf.timesheetEndDate = Utils.dateToCurrentTimeZone(event.value.startDate);
                } else {
                    this.deductionItemConf.timesheetEndDate = null;
                }
            }
        },

        onShowDeductionDialog(data) {
            this.idDeductionSelected = data.id;
            this.clearDialog();
            this.loadDeductionDetail();
            this.getTotatDeductionItem();
            this.deductionDialog = true;
        },

        onShowDialogNewDeduction() {
            this.clearDialog();
            this.idDeductionSelected = null;
            this.getTotatDeductionItem();
            this.deductionDialog = true;
        },

        clearDialog() {
            this.resetDeductionItem();
            this.deductionItems = [];
            this.deduction = {};
        },

        onChangeDeduction(data) {
            this.$store.dispatch('generic/setLoading', true);
            const payload = {
                id: data.id,
                isEntryActive: data.isEntryActive,
                sharePercent: data.sharePercent,
                dateFrom: data.dateFrom,
                dateTo: data.dateTo,
                deductionDescription: data.deductionDescription,
            };
            Service.updateDeductionDetail(payload, (response) => {
                this.$store.dispatch('generic/setLoading', false);
                if (response.success) {
                    this.loadHeader();
                } else {
                    this.$toast.add({ detail: response.message && response.message != '' ? response.message : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                }
            });
        },

        onEditDeductionItem(item) {
            this.deductionItemConf.descriptionItem = item.data.deductionDescription;
            this.deductionItemConf.signSelected = this.signOperations.find((i) => i.value == item.data.isAdd);
            this.deductionItemConf.sourceSelected = this.sourceOperations.find((i) => i.value == (item.data.dateFrom && item.data.dateTo ? true : false));
            this.deductionItemConf.timesheetOptionsEndDate = item.data.idTimesheetDetailEndDate;
            this.deductionItemConf.timesheetOptionsStartDate = item.data.idTimesheetDetailStartDate;
            this.deductionItemConf.timesheetStartDate = item.data.dateFrom ? Utils.dateToCurrentTimeZone(item.data.dateFrom) : null;
            this.deductionItemConf.timesheetEndDate = item.data.dateTo ? Utils.dateToCurrentTimeZone(item.data.dateTo) : null;
            this.deductionItemConf.fixedHrsItem = Math.floor(item.data.totalMinutes / 60);
            this.deductionItemConf.fixedMinsItem = item.data.totalMinutes % 60;
            this.indexDeductionItem = item.index;
        },

        exportExcel(isInternal) {
            this.$store.dispatch('generic/setLoading', true);
            let fileNameWithExtension = this.voyagesSelected ? this.itemsHeader.registryVessel + ' ' + this.voyagesSelected.extraData + '.xlsx' : 'Demurrage_Summary.xlsx';
            const params = {
                isInternal: isInternal,
            };
            Service.exportCalculatorExcel(this.itemsHeader.id, params, (response) => {
                this.$store.dispatch('generic/setLoading', false);
                if (response.success) {
                    var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    var fileLink = document.createElement('a');
                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', fileNameWithExtension);
                    document.body.appendChild(fileLink);
                    fileLink.click();
                } else {
                    this.$toast.add({ detail: message || this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                }
            });
        },

        printTimesheetPdf() {
            let params = {
                id: this.itemsHeader.idTimesheetHeader,
                isPrivate: true,
            };
            this.$store.dispatch('generic/setLoading', true);
            ServiceJetty.printTimesheet(params, (response) => {
                this.$store.dispatch('generic/setLoading', false);
                if (response.success) {
                    var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    var fileLink = document.createElement('a');
                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', 'Timesheet_' + this.voyagesSelected.extraData + '.pdf');
                    document.body.appendChild(fileLink);
                    fileLink.click();
                } else {
                    this.$toast.add({ detail: response.message && response.message != '' ? response.message : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                }
            });
        },

        mapDeliveryDocuments() {
            this.deliveryDocuments = [
                {
                    document: 'Allowed hours for cargo documents delivery',
                    from: this.itemsHeader.cargoDocumentsAllowanceFrom,
                    to: this.itemsHeader.cargoDocumentsAllowanceTo,
                    share: this.itemsHeader.cargoDocumentsAllowanceSharePercent,
                    totalMinutes: this.itemsHeader.cargoDocumentsAllowanceMinutes,
                },
                {
                    document: 'Extra time for cargo documents delivery',
                    from: this.itemsHeader.cargoDocumentsFrom,
                    to: this.itemsHeader.cargoDocumentsTo,
                    share: this.itemsHeader.cargoDocumentsSharePercent,
                    totalMinutes: this.itemsHeader.cargoDocumentsMinutes,
                },
            ];
        },

        onDeliveryDocumentsEditSave() {
            this.itemsHeader.cargoDocumentsAllowanceFrom = this.deliveryDocuments[0].from;
            this.itemsHeader.cargoDocumentsAllowanceTo = this.deliveryDocuments[0].to;
            this.itemsHeader.cargoDocumentsAllowanceSharePercent = this.deliveryDocuments[0].share;
            this.itemsHeader.cargoDocumentsFrom = this.deliveryDocuments[1].from;
            this.itemsHeader.cargoDocumentsTo = this.deliveryDocuments[1].to;
            this.itemsHeader.cargoDocumentsSharePercent = this.deliveryDocuments[1].share;
            this.$store.dispatch('generic/setLoading', true);
            Service.updateCalculatorHeader(this.itemsHeader, (response) => {
                this.$store.dispatch('generic/setLoading', false);
                if (response.success) {
                    this.loadHeader();
                    this.formatDates();
                } else {
                    this.$toast.add({ detail: response.message && response.message != '' ? response.message : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                }
            });
        },

        onShowMailDialog() {
            this.note = '';
            this.mailDialog = true;
        },

        sendMail() {
            this.$store.dispatch('generic/setLoading', true);
            const body = {
                id: this.itemsHeader.id,
                note: this.note,
            };
            Service.sendMail(body, (response) => {
                this.$store.dispatch('generic/setLoading', false);
                if (response.success) {
                    this.mailDialog = false;
                    this.$toast.add({ severity: 'success', summary: 'Success Message', detail: this.$t('messages.operation_message_success'), life: 3000 });
                } else {
                    this.$toast.add({ detail: response.message && response.message != '' ? response.message : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                }
            });
        },

        onEditSimpleDeducion(data) {
            data.isEdit = true;
            data.dateFrom = data.dateFrom ? Utils.dateToCurrentTimeZone(data.dateFrom) : null;
            data.dateTo = data.dateTo ? Utils.dateToCurrentTimeZone(data.dateTo) : null;
        },

        onAddSimpleDeduction() {
            const simpleDeduction = [
                {
                    idDemurrageCalculatorHeader: this.itemsHeader.id,
                    deductionDescription: '',
                    isAdd: true,
                    idTimesheetDetailStartDate: 0,
                    idTimesheetDetailEndDate: 0,
                    totalMinutes: null,
                    dateFrom: null,
                    dateTo: null,
                },
            ];
            const data = {
                id: null,
                idDemurrageCalculatorHeader: this.itemsHeader.id,
                deductionDescription: '',
                sharePercent: 100,
                totalHours: 0,
                totalMinutes: 0,
                children: simpleDeduction,
                isEdit: true,
            };
            this.itemsDetail.push(data);
        },

        onSaveSimpleDeduction(data) {
            if (data.dateFrom && data.dateTo && data.sharePercent && data.deductionDescription) {
                if (data.id != null) {
                    this.onChangeDeduction(data);
                } else {
                    const payload = {
                        id: null,
                        idDemurrageCalculatorHeader: this.itemsHeader.id,
                        deductionDescription: data.deductionDescription,
                        sharePercent: data.sharePercent,
                        children: [
                            {
                                idDemurrageCalculatorHeader: this.itemsHeader.id,
                                deductionDescription: data.deductionDescription,
                                isAdd: true,
                                idTimesheetDetailStartDate: 0,
                                idTimesheetDetailEndDate: 0,
                                totalMinutes: this.formatTotalMins(data.dateTo) - this.formatTotalMins(data.dateFrom),
                                dateFrom: data.dateFrom,
                                dateTo: data.dateTo,
                            },
                        ],
                    };
                    this.$store.dispatch('generic/setLoading', true);
                    Service.createCalculatorDeduction(payload, (response) => {
                        if (response.success) {
                            this.loadHeader();
                            this.$toast.add({ severity: 'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000 });
                        } else {
                            this.$toast.add({ detail: response.message && response.message != '' ? response.message : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                        }
                        this.$store.dispatch('generic/setLoading', false);
                    });
                }
            } else {
                this.$toast.add({ detail: this.$t('DemurrageCalculator.messages.error_valid_deduction'), life: 3000, severity: 'error' });
                this.data.isEdit = true;
            }
        },

        loadReason() {
            this.$store.dispatch('generic/setLoading', true);
            Service.getCalculatorReason(this.itemsHeader.id, (response) => {
                if (response.success) {
                    this.itemsReason = response.data;
                    this.getReasonTotals();
                    this.getDeltaTotals();
                } else {
                    this.$toast.add({ detail: response.message && response.message != '' ? response.message : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                }
            });
            this.$store.dispatch('generic/setLoading', false);
        },

        onAddReason() {
            const data = {
                id: null,
                idDemurrageCalculatorHeader: this.itemsHeader.id,
                reasonDescription: '',
                extendedReasonDescription: '',
                totalHours: 0,
                totalMinutes: 0,
                totalDemurrage: 0,
                sharePercent: 100,
                isEdit: true,
            };
            this.itemsReason.push(data);
        },

        onEditReason(data) {
            data.isEdit = true;
            data.dateFrom = data.dateFrom ? Utils.dateToCurrentTimeZone(data.dateFrom) : null;
            data.dateTo = data.dateTo ? Utils.dateToCurrentTimeZone(data.dateTo) : null;
            data.sharePercent = data.sharePercent ? data.sharePercent : 100;
            data.timeString = data.totalMinutes ? this.formatHrsMins(data.totalMinutes) : '';
        },

        onChangeReason(data) {
            this.$store.dispatch('generic/setLoading', true);
            const payload = {
                id: data.id,
                idDemurrageCalculatorHeader: this.itemsHeader.id,
                reasonDescription: data.reasonDescription,
                extendedReasonDescription: data.extendedReasonDescription,
                dateFrom: data.dateFrom,
                dateTo: data.dateTo,
                sharePercent: data.sharePercent,
                totalMinutes: data.totalMinutes,
            };
            Service.updateReason(payload, (response) => {
                this.$store.dispatch('generic/setLoading', false);
                if (response.success) {
                    this.$toast.add({ severity: 'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000 });
                    this.loadReason();
                } else {
                    this.$toast.add({ detail: response.message && response.message != '' ? response.message : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                }
            });
        },

        onDeleteReason(data, event) {
            this.$confirm.require({
                target: event.currentTarget,
                message: this.$t('messages.delete_message_question'),
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: this.$t('yes'),
                rejectLabel: this.$t('no'),
                accept: () => {
                    this.$store.dispatch('generic/setLoading', true);
                    Service.deleteReason(data.id, (response) => {
                        this.$store.dispatch('generic/setLoading', false);
                        if (response.success) {
                            this.$confirm.close();
                            this.loadReason();
                            this.$toast.add({ severity: 'success', summary: 'Success Message', detail: this.$t('messages.delete_message_success'), life: 3000 });
                        } else {
                            this.$toast.add({ detail: response.message && response.message != '' ? response.message : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                        }
                    });
                },
                reject: () => {
                    this.$confirm.close();
                },
            });
        },
        reproportionateReasons(){
            this.$confirm.require({
                message: this.$t('DemurrageCalculator.reproportionateReasonsMessage'),
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: this.$t('yes'),
                rejectLabel: this.$t('no'),
                accept: () => {
                   Service.reproportionateReasons(this.itemsHeader.id, response => {
                    if(response.success){
                        this.$confirm.close();
                        this.loadReason();
                    }
                   });
                },
                reject: () => {
                    this.$confirm.close();
                }
            });
        },
        onSaveReason(data) {
            let isDateValid = data.dateFrom && data.dateTo && !(data.dateFrom.getTime() == data.dateTo.getTime());

            if (data.dateFrom && data.dateTo && data.dateFrom.getTime() == data.dateTo.getTime()) {
                this.$toast.add({ detail: this.$t('DemurrageCalculator.messages.error_valid_reason_hrs'), life: 3000, severity: 'error' });
                this.data.isEdit = true;
                return;
            }

            if ((isDateValid || data.totalMinutes) && data.reasonDescription && data.sharePercent) {
                if (data.id != null) {
                    this.onChangeReason(data);
                } else {
                    const payload = {
                        idDemurrageCalculatorHeader: this.itemsHeader.id,
                        reasonDescription: data.reasonDescription,
                        extendedReasonDescription: data.extendedReasonDescription,
                        dateFrom: data.dateFrom,
                        dateTo: data.dateTo,
                        sharePercent: data.sharePercent,
                        totalMinutes: data.totalMinutes,
                    };
                    this.$store.dispatch('generic/setLoading', true);
                    Service.createReason(payload, (response) => {
                        if (response.success) {
                            this.loadReason();
                            this.$toast.add({ severity: 'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000 });
                        } else {
                            this.$toast.add({ detail: response.message && response.message != '' ? response.message : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                        }
                        this.$store.dispatch('generic/setLoading', false);
                    });
                }
            } else {
                this.$toast.add({ detail: this.$t('DemurrageCalculator.messages.error_valid_deduction'), life: 3000, severity: 'error' });
                this.data.isEdit = true;
            }
        },

        calculateTotalMinsReasonItems() {
            const total = this.itemsReason.reduce((sum, item) => {
                const value = item.totalMinutes || 0;
                return sum + value;
            }, 0);
            return total;
        },

        calculateTotalDemurrageReasonItems() {
            const total = this.itemsReason.reduce((sum, item) => {
                const value = item.totalDemurrage || 0;
                return sum + value;
            }, 0);
            return total;
        },

        getReasonTotals() {
            this.totalReasonMins = this.calculateTotalMinsReasonItems() ? this.calculateTotalMinsReasonItems().toFixed(0) : 0;
            this.totalReasonHrs = this.formatHrsMins(this.totalReasonMins);
            this.totalReasonTotalHrs = (this.totalReasonMins / 60).toFixed(2);
            this.totalDemurrageReason = this.calculateTotalDemurrageReasonItems();
        },

        getDeltaTotals() {
            this.totalDeltaReasonMins = this.itemsHeader.timeOnDemurrageMinutes - this.totalReasonMins;
            this.totalDeltaReasonHrs = this.formatHrsMins(this.totalDeltaReasonMins);
            this.totalDeltaReasonTotalHrs = (this.totalDeltaReasonMins / 60).toFixed(2);
            const total = (this.itemsHeader.totalDemmurage ? this.itemsHeader.totalDemmurage : 0) - (this.totalDemurrageReason ? this.totalDemurrageReason : 0);
            this.totalDemurrageDeltaReason = total ? total : 0;
        },

        validateAndConvertTime(data) {
            const regex = /^(\d+):([0-5]\d)$/;
            const match = data.timeString?.trim().match(regex);
            if (!match) {
                data.invalidTime = true;
                data.timeString = null;
                data.totalMinutes = null;
                return;
            } else {
                data.invalidTime = false;
            }
            const hours = parseInt(match[1], 10);
            const minutes = parseInt(match[2], 10);
            data.totalMinutes = hours * 60 + minutes;
            data.totalHours = data.totalMinutes != 0 ? (data.totalMinutes / 60).toFixed(2) : 0;
            if (data.totalMinutes == 0) {
                this.$toast.add({ detail: this.$t('DemurrageCalculator.messages.error_valid_reason_hrs'), life: 3000, severity: 'error' });
            }
        },
        downloadDocument({documentGuid, fileName, fileExtension}){
            this.$store.dispatch("generic/setLoading", true);
            let fileNameWithExtension = fileName + fileExtension;
            CommonService.dowloadFile('system/document-manager-download-document', {documentGuid: documentGuid, fileNameWithExtension }, ({success, data, message}) => {
                this.$store.dispatch("generic/setLoading", false);
                
                if(success){
                    var fileURL = window.URL.createObjectURL(new Blob([data]));
                    var fileLink = document.createElement('a');
                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', fileNameWithExtension);
                    document.body.appendChild(fileLink);
                
                    fileLink.click();
                } else{
                    this.$toast.add({ detail: message || this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                }
            })
        },
        deleteDocument(item){
            this.$confirm.require({
                message: this.$t('messages.delete_message_question'),
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: this.$t('yes'),
                rejectLabel: this.$t('no'),
                accept: () => {
                    let docData = {
                        idVesselProtocol: this.vesselProtocolId,
                        documentGuid: item.documentGuid
                    };

                    CommonService.deleteItem('attachments', item.documentGuid, ({success, message}) => {
                        if(success){
                            this.loadAttachments();
                            this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.delete_message_success'), life: 3000});
                        } else{
                            this.$toast.add({ detail: message || this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                        }
                    })
                },
                reject: () => {
                    this.$confirm.close();
                }
            });
        },
        onRemoveTemplatingFile(file, removeFileCallback, index) {
            removeFileCallback(index);
            this.totalSize -= parseInt(this.formatSize(file.size));
            this.totalSizePercent = this.totalSize / 10;
        },
        onClearTemplatingUpload(clear) {
            clear();
            this.totalSize = 0;
            this.totalSizePercent = 0;
        },
        onSelectedFiles(event) {
            this.files = event.files;
            this.files.forEach((file) => {
                this.totalSize += parseInt(this.formatSize(file.size));
            });
        },
        uploadEvent(callback) {
            this.totalSizePercent = this.totalSize / 10;
            callback();
        },
        uploaderResponseMethod(file) {
            const toBase64 = file => new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result.split(',')[1]);
                reader.onerror = reject;
            });
            file.files.forEach(async (document) => {
                const base64 = await toBase64(document);

                let formData = {
                    idVesselProtocol: this.itemsHeader.id,
                    description: this.newDocument.description,
                    fileContentBase64: base64,
                    fileNameWithExtension: document.name
                }
                this.$store.dispatch("generic/setLoading", true);

                this.lastLoaded = null;
                Service.uploadAttachment(formData, ({ success, data, message }) => {
                    this.$store.dispatch("generic/setLoading", false);
                    this.newDocument.description = '';
                    if (success) {
                        this.$toast.add({ detail: this.$t('messages.upload_message_success'), life: 3000, severity: 'success' });
                        this.loadAttachments();
                    } else {
                        this.$toast.add({ detail: message && message != '' ? message : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                    }
                })
            })
        },
        formatSize(bytes) {
            if (bytes === 0) {
                return '0 B';
            }

            let k = 1000,
                dm = 3,
                sizes = ['Byte', 'KiloByte', 'MegaByte', 'GigaByte', 'TeraByte', 'PetaByte', 'EByte', 'ZByte', 'YByte'],
                i = Math.floor(Math.log(bytes) / Math.log(k));

            return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
        },
    },
};
</script>

<template>
    <main>
        <Dialog v-model:visible="regenerateDialog" modal :header="$t('DemurrageCalculator.regenerateTitleDialog') + ' ' + this.voyagesSelected.label" closable :style="{ width: '35vw' }">
            <label>{{ $t('DemurrageCalculator.messages.regenerateCalculator') }}</label>
            <template #footer>
                <div>
                    <ResponsiveButton :label="$t('yes')" text severity="secondary" class="p-button m-1" @click="onRegenerateCalculator(true)" autofocus />
                    <ResponsiveButton :label="$t('no')" text severity="secondary" class="p-button m-1 p-button-outlined" @click="onRegenerateCalculator(false)" autofocus />
                    <ResponsiveButton :label="$t('btn.cancel')" text severity="secondary" class="p-button-outlined p-button-danger m-1" @click="regenerateDialog = false" autofocus />
                </div>
            </template>
        </Dialog>
        <Dialog v-model:visible="mailDialog" :header="$t('DemurrageCalculator.titleDialogMail')" modal closable :style="{ width: '30vw' }">
            <label> {{ this.$t('DemurrageCalculator.messages.send_mail_message') }}</label>
            <div class="grid pt-4">
                <div class="col-12 lg:col-12 field">
                    <Textarea v-model="this.note" :placeholder="this.$t('DemurrageCalculator.note')" class="w-full p-inputtext-sm" rows="5" />
                </div>
            </div>
            <div class="align-right">
                <ResponsiveButton :label="$t('yes')" @click="sendMail()" class="w-48 p-button p-button-sm m-2" />
                <ResponsiveButton :label="$t('no')" @click="mailDialog = false" class="w-48 p-button-outlined p-button-sm m-2" />
            </div>
        </Dialog>
        <Dialog v-model:visible="deductionDialog" :header="$t('DemurrageCalculator.titleDialogCalculator')" modal closable :style="{ width: '70vw' }">
            <div class="grid">
                <div class="col-12 lg:col-6 field mt-2">
                    <label :class="{ 'p-error': !deduction.deductionDescription && submitted }">{{ $t('DemurrageCalculator.name') }}</label>
                    <InputText type="string" v-model="deduction.deductionDescription" :class="{ 'p-invalid': !deduction.deductionDescription && submitted, 'w-full p-inputtext-sm': true }" :readonly="!uiPermissions('DemurrageAdminUI').isEnabled" />
                </div>
                <div class="col-12 lg:col-2 field mt-2">
                    <label :class="{ 'p-error': !deduction.sharePercent && submitted }">{{ $t('DemurrageCalculator.share') }}</label>
                    <InputNumber
                        v-model="deduction.sharePercent"
                        @update:modelValue="getTotatDeductionItem()"
                        suffix="%"
                        :class="{ 'p-invalid': !deduction.sharePercent && submitted, 'w-full p-inputtext-sm': true }"
                        :readonly="!uiPermissions('DemurrageAdminUI').isEnabled"
                    />
                </div>
                <div class="col-12 field">
                    <Fieldset :legend="$t('DemurrageCalculator.deduction')" v-if="uiPermissions('DemurrageAdminUI').isEnabled">
                        <div class="grid formgrid">
                            <div class="col-12 field lg:col-8">
                                <label :class="{ 'p-error': !deductionItemConf.descriptionItem && submitted }">{{ $t('DemurrageCalculator.description') }}</label>
                                <InputText type="string" v-model="deductionItemConf.descriptionItem" :class="{ 'p-invalid': !deductionItemConf.descriptionItem && submitted, 'w-full p-inputtext-sm': true }" />
                            </div>
                        </div>
                        <div class="grid formgrid">
                            <div class="col-12 field lg:col-4">
                                <label :class="{ 'p-error': !deductionItemConf.signSelected && submitted }">{{ $t('DemurrageCalculator.sumAndDifference') }}</label>
                                <Dropdown
                                    :class="{ 'p-invalid': !deductionItemConf.signSelected && submitted, 'w-full p-inputtext-sm': true }"
                                    :placeholder="null"
                                    v-model="deductionItemConf.signSelected"
                                    :options="signOperations"
                                    optionLabel="label"
                                />
                            </div>
                            <div class="col-12 field lg:col-4">
                                <label :class="{ 'p-error': !deductionItemConf.sourceSelected && submitted }">{{ $t('DemurrageCalculator.origin') }}</label>
                                <Dropdown
                                    :class="{ 'p-invalid': !deductionItemConf.sourceSelected && submitted, 'w-full p-inputtext-sm': true }"
                                    :placeholder="null"
                                    v-model="deductionItemConf.sourceSelected"
                                    @change="onChangeSourceSelected"
                                    :options="sourceOperations"
                                    optionLabel="label"
                                />
                            </div>
                            <div class="col-6 field lg:col-4" v-if="deductionItemConf.sourceSelected.value == false">
                                <label :class="{ 'p-error': !deductionItemConf.fixedHrsItem && !deductionItemConf.fixedMinsItem && !deductionItemConf.sourceSelected.value && submitted }">
                                    {{ $t('DemurrageCalculator.value') }}
                                </label>
                                <div class="grid formgrid">
                                    <InputNumber
                                        v-model="deductionItemConf.fixedHrsItem"
                                        placeholder="Hrs"
                                        suffix=" Hrs"
                                        mode="decimal"
                                        showButtons
                                        :min="0"
                                        :class="{ 'p-invalid': !deductionItemConf.fixedHrsItem && !deductionItemConf.fixedMinsItem && !deductionItemConf.sourceSelected.value && submitted, 'w-24 p-inputtext-md pr-1': true }"
                                    />
                                    <InputNumber
                                        v-model="deductionItemConf.fixedMinsItem"
                                        placeholder="Mins"
                                        suffix=" Mins"
                                        mode="decimal"
                                        showButtons
                                        :min="0"
                                        :max="59"
                                        :class="{ 'p-invalid': !deductionItemConf.fixedHrsItem && !deductionItemConf.fixedMinsItem && !deductionItemConf.sourceSelected.value && submitted, 'w-24 p-inputtext-md pr-1': true }"
                                    />
                                </div>
                            </div>
                            <div class="col-12 field lg:col-12" v-if="deductionItemConf.sourceSelected.value == true">
                                <div class="grid formgrid">
                                    <div class="col-12 field lg:col-4">
                                        <label>{{ $t('DemurrageCalculator.entryStart') }}</label>
                                        <GenericCustomAutocompleteV2
                                            ref="timesheetSelectStartDate"
                                            :name="'timesheet-detail-by-movement-instruction'"
                                            v-model="deductionItemConf.timesheetOptionsStartDate"
                                            :onItemSelect="onSelectTimesheetStartDate"
                                            :api="'jetty/vessel-timesheet-detail-get-by-movement-instruction?movementInstructionHeaderId=' + idMovementInstructionHeader"
                                            :format="{ label: (e) => e.registryTimesheetOperationDescription + (e.startDate ? ' - ' + utils.formatDateTime(utils.dateToCurrentTimeZone(e.startDate)) : ''), value: 'id' }"
                                            class="w-full p-inputtext-sm mt-1"
                                        />
                                    </div>

                                    <div class="col-12 field lg:col-4">
                                        <label :class="{ 'p-error': !deductionItemConf.timesheetStartDate && !deductionItemConf.timesheetEndDate && deductionItemConf.sourceSelected.value && submitted }">
                                            {{ $t('DemurrageCalculator.startDate') }}
                                        </label>
                                        <Calendar
                                            v-model="deductionItemConf.timesheetStartDate"
                                            :dateFormat="constants.DATE_FORMAT_POINT"
                                            :showTime="true"
                                            :hideOnDateTimeSelect="true"
                                            :showIcon="true"
                                            :showButtonBar="true"
                                            :yearNavigator="true"
                                            :class="{ 'p-invalid': (!deductionItemConf.timesheetStartDate || !deductionItemConf.timesheetEndDate) && deductionItemConf.sourceSelected && submitted, 'w-full p-inputtext-sm': true }"
                                        />
                                    </div>
                                    <div class="col-12 field lg:col-4"></div>

                                    <div class="col-12 field lg:col-4">
                                        <label>{{ $t('DemurrageCalculator.entryEnd') }}</label>
                                        <GenericCustomAutocompleteV2
                                            ref="timesheetSelectEndDate"
                                            :name="'timesheet-detail-by-movement-instruction'"
                                            v-model="deductionItemConf.timesheetOptionsEndDate"
                                            :onItemSelect="onSelectTimesheetEndDate"
                                            :api="'jetty/vessel-timesheet-detail-get-by-movement-instruction?movementInstructionHeaderId=' + idMovementInstructionHeader"
                                            :format="{
                                                label: (e) =>
                                                    e.registryTimesheetOperationDescription +
                                                    (e.endDate ? ' - ' + utils.formatDateTime(utils.dateToCurrentTimeZone(e.endDate)) : e.startDate ? ' - ' + utils.formatDateTime(utils.dateToCurrentTimeZone(e.startDate)) : ''),
                                                value: 'id',
                                            }"
                                            class="w-full p-inputtext-sm mt-1"
                                        />
                                    </div>
                                    <div class="col-12 field lg:col-4">
                                        <label>{{ $t('DemurrageCalculator.endDate') }}</label>
                                        <Calendar
                                            v-model="deductionItemConf.timesheetEndDate"
                                            :dateFormat="constants.DATE_FORMAT_POINT"
                                            :showTime="true"
                                            :hideOnDateTimeSelect="true"
                                            :showIcon="true"
                                            :showButtonBar="true"
                                            :yearNavigator="true"
                                            :class="{ 'p-invalid': (!deductionItemConf.timesheetStartDate || !deductionItemConf.timesheetEndDate) && deductionItemConf.sourceSelected && submitted, 'w-full p-inputtext-sm': true }"
                                        />
                                    </div>
                                </div>
                            </div>

                            <div class="col-12 field lg:col-2 lg:col-offset-8 align-right p-3 pb-0">
                                <ResponsiveButton :label="$t('btn.add')" icon="pi pi-plus" @click="addDeductionItem()" class="p-button p-button-sm ml-3" />
                            </div>
                        </div>
                    </Fieldset>
                    <div class="grid pt-6">
                        <div class="col-12 field">
                            <DataTable :value="deductionItems" showGridlines stripedRows :reorderableColumns="true">
                                <Column :exportable="false">
                                    <template #body="slotProps">
                                        <Button icon="pi pi-trash" class="p-button-rounded p-button-warning mr-2" v-tooltip="$t('btn.delete')" @click="deleteDeductionItem(slotProps)" v-if="uiPermissions('DemurrageAdminUI').isEnabled" />
                                        <Button icon="pi pi-pencil" class="p-button-rounded p-button-success mr-2" v-tooltip="$t('btn.edit')" @click="onEditDeductionItem(slotProps)" v-if="uiPermissions('DemurrageAdminUI').isEnabled" />
                                    </template>
                                </Column>
                                <Column field="deductionDescription" :header="$t('DemurrageCalculator.reasons')" dataType="string">
                                    <template #body="element">
                                        {{ element.data.deductionDescription }}
                                    </template>
                                </Column>
                                <Column field="from" :header="$t('DemurrageCalculator.from')" dataType="number">
                                    <template #body="element">
                                        {{ element.data.dateFrom ? utils.formatDateTime(utils.dateToCurrentTimeZone(element.data.dateFrom)) : null }}
                                    </template>
                                </Column>
                                <Column field="to" :header="$t('DemurrageCalculator.to')" dataType="number">
                                    <template #body="element">
                                        {{ element.data.dateTo ? utils.formatDateTime(utils.dateToCurrentTimeZone(element.data.dateTo)) : null }}
                                    </template>
                                </Column>
                                <Column field="totalHoursMins" :header="$t('DemurrageCalculator.totalHoursMins')" dataType="number">
                                    <template #body="element">
                                        {{ this.formatHrsMins(element.data.totalMinutes) }}
                                    </template>
                                </Column>
                                <Column field="sign" :header="$t('DemurrageCalculator.sign')" dataType="number">
                                    <template #body="element">
                                        {{ element.data.isAdd ? '+' : '-' }}
                                    </template>
                                </Column>
                                <template #empty>
                                    {{ $t('noRecordsFound') }}
                                </template>
                            </DataTable>
                        </div>
                    </div>
                    <div class="grid formgrid mb-5 pr-6">
                        <div class="col-12 field lg:col-offset-6 lg:col-3">
                            <label>{{ $t('DemurrageCalculator.totalMins') }}</label>
                            <InputText readonly v-model="totalDeductionItemHrs" class="w-full p-inputtext-sm" />
                        </div>
                        <div class="col-12 field lg:col-3">
                            <label>{{ $t('DemurrageCalculator.totalHrs') }}</label>
                            <InputText readonly v-model="totalDeductionItemTotalHrs" class="w-full p-inputtext-sm" />
                        </div>
                    </div>
                    <div class="col-12 field lg:col-3 lg:col-offset-9 align-right">
                        <ResponsiveButton :label="$t('btn.save')" @click="onSaveDeductionDetailItem" icon="pi pi-save" class="p-button p-button-sm p-button-success m-1" v-if="uiPermissions('DemurrageAdminUI').isEnabled" />
                    </div>
                </div>
            </div>
        </Dialog>

        <div class="m-5">
            <div class="grid">
                <div class="col-12 lg:col-4 field">
                    <label for="voyages">{{ $t('DemurrageCalculator.voyage') }}</label>
                    <GenericCustomMasterDataAutocompleteV2
                        ref="voyagesCombo"
                        :changeFn="onVoyageSelected"
                        v-model="this.idMovementInstructionHeader"
                        :queryField="{ getOnlyOpened: onlyOpened, transportType: 'N,B' }"
                        name="voyages-combo-for-demurrage"
                        id="voyages"
                        api="movement-instruction/voyage-number-combo?onlyOpened=false&transportType=N,B"
                        class="w-full p-inputtext-sm"
                    />
                </div>

                <div class="col-12 lg:col-6 field m-5">
                    <ResponsiveButton :label="$t('btn.load')" icon="pi pi-refresh" :disabled="!this.idMovementInstructionHeader" class="p-button m-1" @click="loadHeader()" />
                    <ResponsiveButton
                        :label="$t('DemurrageCalculator.btn.regenerate')"
                        icon="pi pi-sync"
                        @click="regenerateDialog = true"
                        :disabled="!this.isLoaded"
                        class="p-button p-button-danger m-1"
                        v-if="uiPermissions('DemurrageAdminUI').isEnabled"
                    />
                    <SplitButton :label="$t('btn.download')" :model="downloadItems" icon="pi pi-file-excel" class="p-button-success m-1" :disabled="!this.isLoaded" />
                    <ResponsiveButton :label="$t('DemurrageCalculator.btn.sendMail')" icon="pi pi-send" class="p-button m-1" @click="onShowMailDialog()" :disabled="!this.isLoaded" v-if="uiPermissions('DemurrageAdminUI').isEnabled" />
                    <SplitButton :label="$t('btn.timesheet')" :model="timesheetItems" icon="pi pi-download" class="m-1" :disabled="!this.isLoaded" v-if="uiPermissions('DemurrageAdminUI').isEnabled" />
                </div>
            </div>

            <Card v-if="canShowCard">
                <template #content>
                    <div class="grid formgrid mb-5">
                        <div class="col-12 field lg:col-3">
                            <label>{{ $t('DemurrageCalculator.vessel') }}</label>
                            <InputText type="string" v-model="itemsHeader.registryVessel" class="w-full p-inputtext-sm" :readonly="!uiPermissions('DemurrageAdminUI').isEnabled" />
                        </div>
                        <div class="col-12 field lg:col-3">
                            <label>{{ $t('DemurrageCalculator.product') }}</label>
                            <InputText type="string" v-model="itemsHeader.product" class="w-full p-inputtext-sm" :readonly="!uiPermissions('DemurrageAdminUI').isEnabled" />
                        </div>
                        <div class="col-12 field lg:col-3">
                            <label>{{ $t('DemurrageCalculator.loadport') }}</label>
                            <InputText v-model="itemsHeader.loadingPort" type="string" class="w-full p-inputtext-sm" :readonly="!uiPermissions('DemurrageAdminUI').isEnabled" />
                        </div>
                        <div class="col-12 field lg:col-3">
                            <label>{{ $t('DemurrageCalculator.disport') }}</label>
                            <InputText v-model="itemsHeader.dischargePort" type="string" class="w-full p-inputtext-sm" :readonly="!uiPermissions('DemurrageAdminUI').isEnabled" />
                        </div>
                        <div class="col-12 field lg:col-3">
                            <label>{{ $t('DemurrageCalculator.nor') }}</label>
                            <Calendar
                                :readonly="!uiPermissions('DemurrageAdminUI').isEnabled"
                                v-model="itemsHeader.noticeOfReadiness"
                                :dateFormat="constants.DATE_FORMAT_POINT"
                                :showTime="true"
                                :hideOnDateTimeSelect="true"
                                :showIcon="true"
                                :showButtonBar="true"
                                :yearNavigator="true"
                                class="w-full p-inputtext-sm"
                            />
                        </div>
                        <div class="col-12 field lg:col-3">
                            <label>{{ $t('DemurrageCalculator.hosesDisconnection') }}</label>
                            <Calendar
                                :readonly="!uiPermissions('DemurrageAdminUI').isEnabled"
                                v-model="itemsHeader.hosesDisconnection"
                                :dateFormat="constants.DATE_FORMAT_POINT"
                                :showTime="true"
                                :hideOnDateTimeSelect="true"
                                :showIcon="true"
                                :showButtonBar="true"
                                :yearNavigator="true"
                                class="w-full p-inputtext-sm"
                            />
                        </div>
                        <div class="col-12 field lg:col-3">
                            <label>{{ $t('DemurrageCalculator.documentOnBoard') }}</label>
                            <Calendar
                                :readonly="!uiPermissions('DemurrageAdminUI').isEnabled"
                                v-model="itemsHeader.documentOnBoard"
                                :dateFormat="constants.DATE_FORMAT_POINT"
                                :showTime="true"
                                :hideOnDateTimeSelect="true"
                                :showIcon="true"
                                :showButtonBar="true"
                                :yearNavigator="true"
                                class="w-full p-inputtext-sm"
                            />
                        </div>
                        <div class="col-12 field lg:col-3">
                            <label>{{ $t('DemurrageCalculator.contract') }}</label>
                            <GenericCustomMasterDataAutocompleteV2 v-model="itemsHeader.incotermCode" name="incoterms" api="masterdata/incoterm-combo" class="w-full p-inputtext-sm" :disabled="!uiPermissions('DemurrageAdminUI').isEnabled" />
                        </div>
                    </div>
                    <Fieldset :legend="$t('DemurrageCalculator.grossLayout')">
                        <div class="grid formgrid">
                            <div class="col-12 field lg:col-4">
                                <label>{{ $t('DemurrageCalculator.laytimeCommenced') }}</label>
                                <Calendar
                                    :readonly="!uiPermissions('DemurrageAdminUI').isEnabled"
                                    v-model="itemsHeader.layTimeCommenced"
                                    :dateFormat="constants.DATE_FORMAT_POINT"
                                    :showTime="true"
                                    :hideOnDateTimeSelect="true"
                                    :showIcon="true"
                                    :showButtonBar="true"
                                    :yearNavigator="true"
                                    class="w-full p-inputtext-sm"
                                />
                            </div>
                            <div class="col-12 field lg:col-4">
                                <label>{{ $t('DemurrageCalculator.laytimeCompleted') }}</label>
                                <Calendar
                                    :readonly="!uiPermissions('DemurrageAdminUI').isEnabled"
                                    v-model="itemsHeader.hosesDisconnection"
                                    :dateFormat="constants.DATE_FORMAT_POINT"
                                    :showTime="true"
                                    :hideOnDateTimeSelect="true"
                                    :showIcon="true"
                                    :showButtonBar="true"
                                    :yearNavigator="true"
                                    class="w-full p-inputtext-sm"
                                />
                            </div>
                            <div class="col-12 field lg:col-4">
                                <label>{{ $t('DemurrageCalculator.grossLaytime') }}</label>
                                <InputText type="string" v-model="grossLaytime" readonly class="w-full p-inputtext-sm" />
                            </div>
                            <div class="col-12 field lg:col-4">
                                <div class="grid formgrid">
                                    <div class="col-12 field lg:col-4">
                                        <label for="demurrageRate">{{ $t('DemurrageCalculator.demurrageRate') }}</label>
                                        <InputNumber
                                            id="demurrageRate"
                                            :minFractionDigits="2"
                                            :maxFractionDigits="2"
                                            mode="decimal"
                                            v-model="itemsHeader.demurrageRate"
                                            class="w-full p-inputtext-sm m-1"
                                            :readonly="!uiPermissions('DemurrageAdminUI').isEnabled"
                                        />
                                    </div>
                                    <div class="col-12 field lg:col-4">
                                        <label for="currencyCode">{{ $t('currencyCode') }}</label>
                                        <generic-custom-master-data-autocomplete-v-2
                                            :disabled="!uiPermissions('DemurrageAdminUI').isEnabled"
                                            name="currencies"
                                            v-model="itemsHeader.demurrageCurrencyCode"
                                            api="masterdata/currency-combo"
                                            :format="{ label: 'name', value: 'isoCode' }"
                                            sortField="Name"
                                            class="w-full p-inputtext-sm"
                                        />
                                    </div>
                                    <div class="col-12 field lg:col-4">
                                        <label for="laytimeUoMCode">{{ $t('laytimeUoM.fk') }}</label>
                                        <generic-custom-master-data-autocomplete-v-2
                                            name="laytime-uoms"
                                            v-model="itemsHeader.demurrageUoMCode"
                                            api="masterdata/unit-of-measure-combo?scope=MovementInstructionLaytime"
                                            class="w-full p-inputtext-sm"
                                            :disabled="!uiPermissions('DemurrageAdminUI').isEnabled"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 field lg:col-4">
                                <label>{{ $t('DemurrageCalculator.proratedAllowedLaytime') }}</label>
                                <!-- <InputText type="string" v-model="itemsHeader.proratedAllowedLaytime" class="w-full p-inputtext-sm" :readonly="!uiPermissions('DemurrageAdminUI').isEnabled" /> -->
                                <HourMinuteField v-model="itemsHeader.proratedAllowedLaytime" class="w-full p-inputtext-sm" :readonly="!uiPermissions('DemurrageAdminUI').isEnabled" />
                            </div>
                            <div class="col-12 field lg:col-4">
                                <label>{{ $t('DemurrageCalculator.layday') }}</label>
                                <InputText type="string" v-model="layday" readonly class="w-full p-inputtext-sm" />
                            </div>
                        </div>
                    </Fieldset>
                    <div class="align-right p-3">
                        <ResponsiveButton :label="$t('btn.save')" @click="updateHeader()" icon="pi pi-save" class="p-button p-button-sm p-button-success m-1" v-if="uiPermissions('DemurrageAdminUI').isEnabled" />
                    </div>

                    <div>
                        <div class="grid m-3">
                            <h5>{{ $t('DemurrageCalculator.deductions') }}</h5>
                            <ResponsiveButton
                                :label="$t('DemurrageCalculator.btn.simpleDeduction')"
                                v-tooltip="$t('DemurrageCalculator.btn.simpleDeduction')"
                                icon="pi pi-plus"
                                @click="onAddSimpleDeduction"
                                class="p-button p-button-sm ml-5 mb-4"
                                v-if="uiPermissions('DemurrageAdminUI').isEnabled"
                            />
                            <ResponsiveButton
                                :label="$t('DemurrageCalculator.btn.composedDeduction')"
                                v-tooltip="$t('DemurrageCalculator.btn.composedDeduction')"
                                icon="pi pi-plus"
                                @click="onShowDialogNewDeduction"
                                class="p-button-outlined p-button-sm ml-2 mb-4"
                                v-if="uiPermissions('DemurrageAdminUI').isEnabled"
                            />
                            <div class="col-12">
                                <DataTable :value="itemsDetail" showGridlines stripedRows :reorderableColumns="false">
                                    <Column field="isEntryActive" headerStyle="width: 3rem">
                                        <template #body="slotProps">
                                            <Checkbox v-model="slotProps.data.isEntryActive" :binary="true" @change="onChangeDeduction(slotProps.data)" :disabled="!uiPermissions('DemurrageAdminUI').isEnabled" />
                                        </template>
                                    </Column>

                                    <Column :exportable="false" headerStyle="width: 10rem">
                                        <template #body="slotProps">
                                            <Button
                                                :icon="uiPermissions('DemurrageAdminUI').isEnabled ? 'pi pi-pencil' : 'pi pi-eye'"
                                                class="p-button-rounded p-button-success m-2"
                                                v-tooltip="$t('btn.edit')"
                                                @click="onShowDeductionDialog(slotProps.data)"
                                                v-if="slotProps.data.isComposed == true"
                                            />
                                            <Button
                                                v-if="uiPermissions('DemurrageAdminUI').isEnabled && !slotProps.data.isComposed && !slotProps.data.isEdit"
                                                icon="pi pi-pencil"
                                                class="p-button-rounded p-button-success m-2"
                                                v-tooltip="$t('btn.edit')"
                                                @click="onEditSimpleDeducion(slotProps.data)"
                                            />
                                            <Button
                                                v-if="uiPermissions('DemurrageAdminUI').isEnabled && !slotProps.data.isComposed && slotProps.data.isEdit"
                                                icon="pi pi-check"
                                                class="p-button-rounded p-button-outlined p-button-success m-2"
                                                v-tooltip="$t('btn.edit')"
                                                @click="onSaveSimpleDeduction(slotProps.data)"
                                            />
                                            <Button
                                                v-if="uiPermissions('DemurrageAdminUI').isEnabled && !slotProps.data.isComposed && slotProps.data.isEdit"
                                                icon="pi pi-times"
                                                class="p-button-rounded p-button-outlined p-button-danger m-2"
                                                v-tooltip="$t('btn.delete')"
                                                @click="slotProps.data.id ? this.loadDetail() : this.itemsDetail.splice(slotProps.index, 1)"
                                            />
                                            <Button
                                                icon="pi pi-trash"
                                                class="p-button-rounded p-button-warning m-2"
                                                v-tooltip="$t('btn.delete')"
                                                @click="onDeleteDetailDeduction(slotProps.data, $event)"
                                                v-if="uiPermissions('DemurrageAdminUI').isEnabled && slotProps.data.id"
                                            />
                                        </template>
                                    </Column>

                                    <Column field="deductionDescription" :header="$t('DemurrageCalculator.reasons')" dataType="string" style="min-width: 100px; max-width: 100px">
                                        <template #body="element">
                                            <div v-if="element.data.isEdit && !element.data.isComposed">
                                                <InputText type="string" v-model="element.data.deductionDescription" class="w-full p-inputtext-sm" :readonly="!uiPermissions('DemurrageAdminUI').isEnabled" />
                                            </div>
                                            <span v-else>
                                                {{ element.data.deductionDescription }}
                                            </span>
                                        </template>
                                    </Column>

                                    <Column field="dateFrom" :header="$t('DemurrageCalculator.from')" dataType="date" style="min-width: 100px; max-width: 100px">
                                        <template #body="element">
                                            <div v-if="element.data.isEdit && !element.data.isComposed">
                                                <Calendar
                                                    v-model="element.data.dateFrom"
                                                    :dateFormat="constants.DATE_FORMAT_POINT"
                                                    :showTime="true"
                                                    :hideOnDateTimeSelect="true"
                                                    :showIcon="true"
                                                    :showButtonBar="true"
                                                    :yearNavigator="true"
                                                    class="w-full p-inputtext-sm"
                                                />
                                            </div>
                                            <span v-else>
                                                {{ element.data.dateFrom != null ? utils.formatDateTime(utils.dateToCurrentTimeZone(element.data.dateFrom)) : null }}
                                            </span>
                                        </template>
                                    </Column>
                                    <Column field="dateTo" :header="$t('DemurrageCalculator.to')" dataType="date" style="min-width: 100px; max-width: 100px">
                                        <template #body="element">
                                            <div v-if="element.data.isEdit && !element.data.isComposed">
                                                <Calendar
                                                    v-model="element.data.dateTo"
                                                    :dateFormat="constants.DATE_FORMAT_POINT"
                                                    :showTime="true"
                                                    :hideOnDateTimeSelect="true"
                                                    :showIcon="true"
                                                    :showButtonBar="true"
                                                    :yearNavigator="true"
                                                    class="w-full p-inputtext-sm"
                                                />
                                            </div>
                                            <span v-else> {{ element.data.dateTo != null ? utils.formatDateTime(utils.dateToCurrentTimeZone(element.data.dateTo)) : null }} </span>
                                        </template>
                                    </Column>
                                    <Column field="sharePercent" :header="$t('DemurrageCalculator.share')" dataType="number" style="width: 100px">
                                        <template #body="element">
                                            <div v-if="element.data.isEdit && !element.data.isComposed">
                                                <InputNumber v-model="element.data.sharePercent" class="w-full p-inputtext-sm" :disabled="!uiPermissions('DemurrageAdminUI').isEnabled" />
                                            </div>
                                            <span v-else> {{ element.data.sharePercent }} </span>
                                        </template>
                                    </Column>
                                    <Column field="totalMinutes" :header="$t('DemurrageCalculator.totalHoursMins')" dataType="string">
                                        <template #body="element">
                                            <div v-if="element.data.isEdit && !element.data.isComposed">
                                                {{ element.data.dateTo && element.data.dateFrom ? this.formatHrsMins(this.calculateSimpleMinsDeduction(element.data.dateTo, element.data.dateFrom, element.data.sharePercent)) : '00:00' }}
                                            </div>
                                            <span v-else> {{ this.formatHrsMins(element.data.totalMinutes) }} </span>
                                        </template>
                                    </Column>
                                    <Column field="totalHours" :header="$t('DemurrageCalculator.totalHours')" dataType="string">
                                        <template #body="element">
                                            <div v-if="element.data.isEdit && !element.data.isComposed">
                                                {{ element.data.dateTo && element.data.dateFrom ? (this.calculateSimpleMinsDeduction(element.data.dateTo, element.data.dateFrom, element.data.sharePercent) / 60).toFixed(2) : 0.0 }}
                                            </div>
                                            <span v-else> {{ element.data.totalHours.toFixed(2) }} </span>
                                        </template>
                                    </Column>
                                    <template #empty>
                                        {{ $t('noRecordsFound') }}
                                    </template>
                                </DataTable>
                            </div>
                        </div>
                    </div>

                    <div>
                        <div class="grid m-3">
                            <h5>{{ $t('DemurrageCalculator.deliveryDocuments') }}</h5>
                            <div class="col-12">
                                <DataTable :value="deliveryDocuments" showGridlines stripedRows :reorderableColumns="false">
                                    <Column field="document" dataType="string">
                                        <template #body="element">
                                            {{ element.data.document }}
                                        </template>
                                    </Column>
                                    <Column field="from" :header="$t('DemurrageCalculator.from')" style="width: 150px">
                                        <template #body="{ data, field }">
                                            <Calendar
                                                class="w-full"
                                                v-model="data[field]"
                                                @update:modelValue="onDeliveryDocumentsEditSave(data)"
                                                appendTo="body"
                                                :placeholder="constants.DATE_PLACEHOLDER_POINT"
                                                :dateFormat="constants.DATE_FORMAT_POINT"
                                                :showButtonBar="true"
                                                :yearNavigator="true"
                                                :showClearButton="false"
                                                :showTime="true"
                                                :disabled="!uiPermissions('DemurrageAdminUI').isEnabled"
                                            />
                                        </template>
                                    </Column>
                                    <Column field="to" :header="$t('DemurrageCalculator.to')" style="width: 150px">
                                        <template #body="{ data, field }">
                                            <Calendar
                                                class="w-full"
                                                v-model="data[field]"
                                                @update:modelValue="onDeliveryDocumentsEditSave(data)"
                                                appendTo="body"
                                                :placeholder="constants.DATE_PLACEHOLDER_POINT"
                                                :dateFormat="constants.DATE_FORMAT_POINT"
                                                :showButtonBar="true"
                                                :yearNavigator="true"
                                                :showClearButton="false"
                                                :showTime="true"
                                                :disabled="!uiPermissions('DemurrageAdminUI').isEnabled"
                                            />
                                        </template>
                                    </Column>
                                    <Column field="share" :header="$t('DemurrageCalculator.share')" dataType="number" style="width: 100px">
                                        <template #body="element">
                                            <InputNumber v-model="element.data.share" class="w-full p-inputtext-sm" @update:modelValue="onDeliveryDocumentsEditSave(data)" :disabled="!uiPermissions('DemurrageAdminUI').isEnabled" />
                                        </template>
                                    </Column>
                                    <Column field="totalMinutes" :header="$t('DemurrageCalculator.totalHoursMins')" dataType="string" style="width: 150px">
                                        <template #body="element">
                                            {{ this.formatHrsMins(element.data.totalMinutes) }}
                                        </template>
                                    </Column>
                                    <Column field="totalMinutes" :header="$t('DemurrageCalculator.totalHours')" dataType="string" style="width: 150px">
                                        <template #body="element">
                                            {{ (element.data.totalMinutes / 60).toFixed(2) }}
                                        </template>
                                    </Column>
                                    <template #empty>
                                        {{ $t('noRecordsFound') }}
                                    </template>
                                </DataTable>
                            </div>
                        </div>
                    </div>

                    <Divider />
                    <div class="">
                        <div class="grid formgrid">
                            <div class="col-12 field lg:col-3 lg:col-offset-6">
                                <label>{{ $t('DemurrageCalculator.totalDeductionMins') }}</label>
                                <InputText v-model="this.totalDeductionsMinutes" readonly class="w-full p-inputtext-sm text-red" />
                            </div>
                            <div class="col-12 field lg:col-3">
                                <label>{{ $t('DemurrageCalculator.totalDeduction') }}</label>
                                <InputText v-model="this.itemsHeader.totalDeductionsHours" readonly class="w-full p-inputtext-sm text-red" />
                            </div>
                            <div class="col-12 field lg:col-3 lg:col-offset-6">
                                <label>{{ $t('DemurrageCalculator.totalNetUsedTimeMins') }}</label>
                                <InputText v-model="this.totalNetUsedtimeMinutes" readonly class="w-full p-inputtext-sm text-red" />
                            </div>
                            <div class="col-12 field lg:col-3">
                                <label>{{ $t('DemurrageCalculator.totalNetUsedTime') }}</label>
                                <InputText v-model="this.itemsHeader.netLaytimeHours" readonly class="w-full p-inputtext-sm text-red" />
                            </div>
                             <div class="col-12 field lg:col-3 lg:col-offset-6">
                                <label>{{ $t('DemurrageCalculator.timeOnDemurrageMins') }}</label>
                                <InputText v-model="this.timeOnDemurrageMinutes" readonly :class="this.itemsHeader.timeOnDemurrageMinutes > 0 ? ' w-full p-inputtext-sm text-red' : 'w-full p-inputtext-sm'" />
                            </div>
                            <div class="col-12 field lg:col-3">
                                <label>{{ $t('DemurrageCalculator.timeOnDemurrage') }}</label>
                                <InputNumber v-model="this.itemsHeader.timeOnDemurrageHours" readonly class="w-full p-inputtext-sm" :inputClass="this.itemsHeader.timeOnDemurrageHours > 0 ? 'text-red' : ''" />
                            </div>

                            <div class="col-12 field lg:col-3 lg:col-offset-9 pb-1">
                                <label class="font-bold">{{ $t('DemurrageCalculator.total') }} ({{ this.itemsHeader.demurrageCurrencyCode }}) </label>
                                <InputNumber
                                    v-model="this.itemsHeader.totalDemmurage"
                                    :minFractionDigits="2"
                                    :maxFractionDigits="2"
                                    mode="decimal"
                                    readonly
                                    class="w-full p-inputtext-sm"
                                    :inputClass="this.itemsHeader.totalDemmurage > 0 ? 'text-red' : ''"
                                />
                            </div>
                        </div>
                    </div>

                    <Divider />

                    <div>
                        <div class="grid m-3">
                            <h5>{{ $t('DemurrageCalculator.demurrageReason') }}</h5>
                            <ResponsiveButton
                                :label="$t('DemurrageCalculator.btn.reason')"
                                v-tooltip="$t('DemurrageCalculator.btn.reason')"
                                icon="pi pi-plus"
                                @click="onAddReason"
                                class="p-button p-button-sm ml-5 mb-4"
                                v-if="uiPermissions('DemurrageAdminUI').isEnabled"
                            />

                            <div class="col-12">
                                <DataTable :value="itemsReason" showGridlines stripedRows :reorderableColumns="false">
                                    <Column :exportable="false" headerStyle="width: 10rem">
                                        <template #body="slotProps">
                                            <Button
                                                v-if="uiPermissions('DemurrageAdminUI').isEnabled && !slotProps.data.isComposed && !slotProps.data.isEdit"
                                                icon="pi pi-pencil"
                                                class="p-button-rounded p-button-success m-2"
                                                v-tooltip="$t('btn.edit')"
                                                @click="onEditReason(slotProps.data)"
                                            />
                                            <Button
                                                v-if="uiPermissions('DemurrageAdminUI').isEnabled && !slotProps.data.isComposed && slotProps.data.isEdit"
                                                icon="pi pi-check"
                                                class="p-button-rounded p-button-outlined p-button-success m-2"
                                                v-tooltip="$t('btn.edit')"
                                                @click="onSaveReason(slotProps.data)"
                                            />
                                            <Button
                                                v-if="uiPermissions('DemurrageAdminUI').isEnabled && !slotProps.data.isComposed && slotProps.data.isEdit"
                                                icon="pi pi-times"
                                                class="p-button-rounded p-button-outlined p-button-danger m-2"
                                                v-tooltip="$t('btn.delete')"
                                                @click="slotProps.data.id ? this.loadReason() : this.itemsReason.splice(slotProps.index, 1)"
                                            />
                                            <Button
                                                icon="pi pi-trash"
                                                class="p-button-rounded p-button-warning m-2"
                                                v-tooltip="$t('btn.delete')"
                                                @click="onDeleteReason(slotProps.data, $event)"
                                                v-if="uiPermissions('DemurrageAdminUI').isEnabled && slotProps.data.id"
                                            />
                                        </template>
                                    </Column>

                                    <Column field="reasonDescription" :header="$t('DemurrageCalculator.reasons')" dataType="string" style="min-width: 200px; max-width: 100px">
                                        <template #body="element">
                                            <div v-if="element.data.isEdit && !element.data.isComposed">
                                                <InputText type="string" v-model="element.data.reasonDescription" class="w-full p-inputtext-sm" :readonly="!uiPermissions('DemurrageAdminUI').isEnabled" />
                                            </div>
                                            <span v-else>
                                                {{ element.data.reasonDescription }}
                                            </span>
                                        </template>
                                    </Column>

                                    <Column field="extendedReasonDescription" :header="$t('DemurrageCalculator.extendedReasonDescription')" dataType="string" style="min-width: 200px; max-width: 100px">
                                        <template #body="element">
                                            <div v-if="element.data.isEdit && !element.data.isComposed">
                                                <InputText type="string" v-model="element.data.extendedReasonDescription" class="w-full p-inputtext-sm" :readonly="!uiPermissions('DemurrageAdminUI').isEnabled" />
                                            </div>
                                            <span v-else>
                                                {{ element.data.extendedReasonDescription }}
                                            </span>
                                        </template>
                                    </Column>

                                    <Column field="dateFrom" :header="$t('DemurrageCalculator.from')" dataType="date" style="min-width: 100px; max-width: 100px">
                                        <template #body="element">
                                            <div v-if="element.data.isEdit && !element.data.isComposed">
                                                <Calendar
                                                    v-model="element.data.dateFrom"
                                                    :dateFormat="constants.DATE_FORMAT_POINT"
                                                    :showTime="true"
                                                    :hideOnDateTimeSelect="true"
                                                    :showIcon="true"
                                                    :showButtonBar="true"
                                                    :yearNavigator="true"
                                                    class="w-full p-inputtext-sm"
                                                />
                                            </div>
                                            <span v-else>
                                                {{ element.data.dateFrom != null ? utils.formatDateTime(utils.dateToCurrentTimeZone(element.data.dateFrom)) : null }}
                                            </span>
                                        </template>
                                    </Column>
                                    <Column field="dateTo" :header="$t('DemurrageCalculator.to')" dataType="date" style="min-width: 100px; max-width: 100px">
                                        <template #body="element">
                                            <div v-if="element.data.isEdit && !element.data.isComposed">
                                                <Calendar
                                                    v-model="element.data.dateTo"
                                                    :dateFormat="constants.DATE_FORMAT_POINT"
                                                    :showTime="true"
                                                    :hideOnDateTimeSelect="true"
                                                    :showIcon="true"
                                                    :showButtonBar="true"
                                                    :yearNavigator="true"
                                                    class="w-full p-inputtext-sm"
                                                />
                                            </div>
                                            <span v-else> {{ element.data.dateTo != null ? utils.formatDateTime(utils.dateToCurrentTimeZone(element.data.dateTo)) : null }} </span>
                                        </template>
                                    </Column>
                                    <Column field="sharePercent" :header="$t('DemurrageCalculator.share')" dataType="number" style="width: 100px">
                                        <template #body="element">
                                            <div v-if="element.data.isEdit && !element.data.isComposed">
                                                <InputNumber v-model="element.data.sharePercent" class="w-full p-inputtext-sm" />
                                            </div>
                                            <span v-else> {{ element.data.sharePercent }} </span>
                                        </template>
                                    </Column>
                                    <Column field="totalMinutes" :header="$t('DemurrageCalculator.totalHoursMins')" dataType="string" style="min-width: 50px; max-width: 50px">
                                        <template #body="element">
                                            <div v-if="element.data.isEdit && !element.data.isComposed && element.data.dateTo && element.data.dateFrom">
                                                {{ element.data.dateTo && element.data.dateFrom ? this.formatHrsMins(this.calculateSimpleMinsDeduction(element.data.dateTo, element.data.dateFrom, element.data.sharePercent)) : '00:00' }}
                                            </div>
                                            <div v-else-if="element.data.isEdit && !element.data.isComposed">
                                                <InputText v-model="element.data.timeString" placeholder="HH:mm" @blur="validateAndConvertTime(element.data)" :class="{ 'p-invalid': element.data.invalidTime, 'w-full p-inputtext-sm': true }" />
                                                <small v-if="element.data.invalidTime" class="p-error"> {{ this.$t('DemurrageCalculator.messages.error_valid_hrs_minutes') }} </small>
                                            </div>
                                            <div v-if="!element.data.isEdit && !element.data.isComposed">
                                                {{ this.formatHrsMins(element.data.totalMinutes) }}
                                            </div>
                                        </template>
                                    </Column>
                                    <Column field="totalHours" :header="$t('DemurrageCalculator.totalHours')" dataType="string" style="min-width: 50px; max-width: 50px">
                                        <template #body="element">
                                            <div v-if="element.data.isEdit && !element.data.isComposed && element.data.dateTo && element.data.dateFrom">
                                                {{ element.data.dateTo && element.data.dateFrom ? (this.calculateSimpleMinsDeduction(element.data.dateTo, element.data.dateFrom, element.data.sharePercent) / 60).toFixed(2) : 0.0 }}
                                            </div>
                                            <div v-else-if="element.data.isEdit && !element.data.isComposed && element.data.totalMinutes">
                                                {{ element.data.totalHours ? element.data.totalHours : 0.0 }}
                                            </div>
                                            <span v-else> {{ element.data.totalHours.toFixed(2) }} </span>
                                        </template>
                                    </Column>
                                    <Column field="totalDemurrage" :header="$t('DemurrageCalculator.totalDemurrage')" dataType="string" style="min-width: 50px; max-width: 50px">
                                        <template #body="element">
                                            <span> {{ element.data.totalDemurrage ? utils.formatDecimal(element.data.totalDemurrage) : '' }} {{ element.data.totalDemurrage ? this.itemsHeader.demurrageCurrencyCode : '' }}</span>
                                        </template>
                                    </Column>
                                    <template #empty>
                                        {{ $t('noRecordsFound') }}
                                    </template>
                                </DataTable>
                            </div>
                        </div>
                    </div>

                    <Divider />
                    <div>
                        <div class="grid formgrid">
                            <div class="col-12 field lg:col-2 lg:col-offset-6">
                                <label>{{ $t('DemurrageCalculator.demurrageReasonHrsMins') }}</label>
                                <InputText v-model="this.totalReasonHrs" readonly class="w-full p-inputtext-sm" />
                            </div>
                            <div class="col-12 field lg:col-2">
                                <label>{{ $t('DemurrageCalculator.demurrageReasonHrs') }}</label>
                                <InputText v-model="this.totalReasonTotalHrs" readonly class="w-full p-inputtext-sm" />
                            </div>

                            <div class="col-12 field lg:col-2">
                                <label>{{ $t('DemurrageCalculator.demurrageReasonTotal') }}</label>
                                <InputNumber :minFractionDigits="2" :maxFractionDigits="2" mode="decimal" v-model="this.totalDemurrageReason" readonly class="w-full p-inputtext-sm" />
                            </div>

                            <div class="col-12 field lg:col-2 lg:col-offset-6">
                                <label>{{ $t('DemurrageCalculator.timeOnDemurrageMins') }}</label>
                                <InputText v-model="this.timeOnDemurrageMinutes" readonly class="w-full p-inputtext-sm" />
                            </div>
                            <div class="col-12 field lg:col-2">
                                <label>{{ $t('DemurrageCalculator.timeOnDemurrage') }}</label>
                                <InputText v-model="this.itemsHeader.timeOnDemurrageHours" readonly class="w-full p-inputtext-sm" />
                            </div>

                            <div class="col-12 field lg:col-2">
                                <label>{{ $t('DemurrageCalculator.totalDemurrage') }} </label>
                                <InputNumber v-model="this.itemsHeader.totalDemmurage" :minFractionDigits="2" :maxFractionDigits="2" mode="decimal" readonly class="w-full p-inputtext-sm" />
                            </div>

                            <div class="col-12 field lg:col-2 lg:col-offset-6">
                                <label>{{ $t('DemurrageCalculator.demurrageDeltaHrsMins') }}</label>
                                <InputText v-model="this.totalDeltaReasonHrs" readonly class="w-full p-inputtext-sm" />
                                <Button
                                    v-if="uiPermissions('DemurrageAdminUI').isEnabled && totalDeltaReasonMins < 0"
                                    icon="pi pi-check"
                                    class="p-button-rounded p-button-outlined p-button-success m-2"
                                    :label="$t('DemurrageCalculator.reproportionateBtn')"
                                    @click="reproportionateReasons()" />
                            </div>
                           
                            <div class="col-12 field lg:col-2">
                                <label>{{ $t('DemurrageCalculator.demurrageDeltaHrs') }}</label>
                                <InputText v-model="this.totalDeltaReasonTotalHrs" readonly class="w-full p-inputtext-sm" />
                            </div>

                            <div class="col-12 field lg:col-2">
                                <label>{{ $t('DemurrageCalculator.demurrageDeltaTotal') }} </label>
                                <InputNumber v-model="this.totalDemurrageDeltaReason" :minFractionDigits="2" :maxFractionDigits="2" readonly mode="decimal" class="w-full p-inputtext-sm" />
                            </div>
                        </div>
                    </div>

                    <Divider />

                    <div>
                        <div class="grid formgrid">
                            <div class="col-10 field col-offset-1">
                                <label>{{ $t('DemurrageCalculator.note') }}</label>
                                <Textarea v-model="this.itemsHeader.note" :placeholder="this.$t('DemurrageCalculator.note')" class="w-full p-inputtext-sm" rows="5" :readonly="!uiPermissions('DemurrageAdminUI').isEnabled" />
                            </div>
                            <div class="col-10 field col-offset-1">
                                <label>{{ $t('DemurrageCalculator.internalNote') }}</label>
                                <Textarea v-model="this.itemsHeader.internalNote" :placeholder="this.$t('DemurrageCalculator.internalNote')" class="w-full p-inputtext-sm" rows="5" :readonly="!uiPermissions('DemurrageAdminUI').isEnabled" />
                            </div>
                        </div>

                        <div class="align-right p-3">
                            <ResponsiveButton :label="$t('btn.save')" @click="updateHeader()" icon="pi pi-save" class="p-button p-button-sm p-button-success m-1" v-if="uiPermissions('DemurrageAdminUI').isEnabled" />
                        </div>
                    </div>
                    <Divider />
                    <div class="grid  m-3">
                        <h5>{{ $t('btn.attachments') }}</h5>
                        
                        <div class="col-12" v-if="!uiPermissions('DemurrageAdminUI').isHidden">
                            <FileUpload name="uploaded[]" customUpload @uploader="uploaderResponseMethod" :fileLimit="10" :previewWidth="0" :multiple="true" >
                            <template #header="{ chooseCallback, uploadCallback, clearCallback, files }">
                                <div class="flex flex-wrap justify-content-between align-items-center flex-1 gap-2">
                                <div class="flex">
                                    <ResponsiveButton :label="$t('btn.selectDocuments')" icon="pi pi-file" class="p-button-outlined m-1" @click="chooseCallback()" />
                                    <ResponsiveButton :label="$t('btn.send')" icon="pi pi-cloud-upload" class="p-button-outlined m-1 p-button-success" @click="uploadEvent(uploadCallback)" severity="success" :disabled="!files || files.length === 0"/>
                                </div>
                                <div class="flex">
                                    <ResponsiveButton :label="$t('btn.cancelDocuments')" icon="pi pi-times" class="p-button-outlined m-1 p-button-danger ms-auto" @click="clearCallback()" severity="danger" :disabled="!files || files.length === 0" />
                                </div>
                                </div>
                            </template>
                            <template #content="{ files, uploadedFiles, removeUploadedFileCallback, removeFileCallback }">
                                <div v-if="files.length > 0">
                                <h5>{{$t('readyToSend')}}</h5>
                                <div class="flex flex-wrap p-0 sm:p-5 gap-5">
                                    <div v-for="(file, index) of files" :key="file.name + file.type + file.size" class="card m-0 px-6 flex flex-column border-1 surface-border align-items-center gap-3">
                                    <span class="font-semibold">{{ file.name }}</span>
                                    <div>{{ formatSize(file.size) }}</div>
                                    <Badge :value="$t('readyToSend')" severity="warning" class="mt-2" />
                                    <Button icon="pi pi-times" class="mt-2 p-button-danger" @click="onRemoveTemplatingFile(file, removeFileCallback, index)" outlined rounded  severity="danger" />
                                    </div>
                                </div>
                                </div>
                                <div v-if="uploadedFiles.length > 0">
                                <h5>{{$t('Imported')}}</h5>
                                <div class="flex flex-wrap p-0 sm:p-5 gap-5">
                                    <div v-for="(file, index) of uploadedFiles" :key="file.name + file.type + file.size" class="card m-0 px-6 flex flex-column border-1 surface-border align-items-center gap-3">
                                    <div>
                                        <img role="presentation" :alt="file.name" :src="file.objectURL" width="100" height="50" class="shadow-2" />
                                    </div>
                                    <span class="font-semibold">{{ file.name }}</span>
                                    <div>{{ formatSize(file.size) }}</div>
                                    <Badge :value="$t('Imported')" class="mt-3" severity="success" />
                                    <Button icon="pi pi-times" @click="removeUploadedFileCallback(index)" outlined rounded  severity="danger" />
                                    </div>
                                </div>
                                </div>
                            </template>
                            <template #empty>
                                <div class="flex align-items-center justify-content-center flex-column">
                                <i class="pi pi-cloud-upload border-2 border-circle p-5 text-8xl text-400 border-400" />
                                <p class="mt-4 mb-0">{{ $t('vesselProtocol.dragAndDropFile')}}</p>
                                </div>
                            </template>
                            </FileUpload>
                        </div>
                        <div class="col-12" v-if="!uiPermissions('DemurrageAdminUI').isHidden">
                            <label for="description">{{$t('description')}}</label>
                            <Textarea name="description" v-model="newDocument.description" class="w-full" rows="5"/>
                        </div>
                        <DataTable :value="demurrageAttachments" showGridlines stripedRows :reorderableColumns="true" class="col-12">
                            <Column>
                                <template #body="slotProps">
                                    <ResponsiveButton icon="pi pi-download" v-tooltip="$t('btn.download')" class="p-button-rounded p-button-outlined" @click="downloadDocument(slotProps.data)" v-if="slotProps.data.documentGuid" />
                                </template>
                            </Column>
                            <Column field="fileName" :header="$t('vesselProtocol.fileName')" :sortable="true" />
                            <Column field="description" :header="$t('vesselProtocol.description')" :sortable="true" />
                            <Column field="createdBy" :header="$t('vesselProtocol.createdBy')" :sortable="true"  />
                            <Column field="documentDate" :header="$t('documentDate')" :sortable="true">
                                <template #body="element">
                                {{element.data.documentDate ? utils.formatDateTime(utils.dateToCurrentTimeZone(element.data.documentDate)) : null}}
                                </template>
                            </Column>
                            <Column>
                                <template #body="slotProps">
                                    <ResponsiveButton icon="pi pi-trash" v-tooltip="$t('btn.delete')" class="p-button-rounded p-button-outlined p-button-danger mr-2" @click="deleteDocument(slotProps.data)" :disabled="!uiPermissions('DemurrageAdminUI').isEnabled" />
                                </template>
                            </Column>
                        </DataTable>
                    </div>
                </template>
            </Card>
        </div>
    </main>
</template>

<style scoped>
.align-right {
    display: flex;
    justify-content: flex-end;
}
</style>
